// V0 Final JavaScript - Clean Implementation

// 翻訳ファイルを動的に読み込み（Liquid asset_urlが使えないため、直接CDN URLを使用）
(function () {
  if (typeof productTranslations === 'undefined') {
    const script = document.createElement('script');
    script.src = '/cdn/shop/t/49/assets/product_translations.js';
    script.async = false;
    document.head.appendChild(script);
  }
})();

const V0_DEBUG = false; // 本番環境では無効化
const debugLog = () => { }; // 本番環境では何も出力しない

class V0App {
  constructor() {
    this.initialized = false;
    this.currentFilters = null; // 現在のフィルター状態を保持
    // 翻訳テーブル（英語ページ対応：2025-12-04追加）
    this.translations = {
      'お気に入りに追加しました': 'Added to favorites',
      'お気に入りから削除しました': 'Removed from favorites',
      'リンクをコピーしました': 'Link copied',
      'コピーに失敗しました': 'Copy failed',
      'カートに追加しました': 'Added to cart',
      'この商品はすでにカートに入っています。': 'This item is already in your cart.',
      'カートへの追加に失敗しました': 'Failed to add to cart',
      'カートの確認に失敗しました': 'Failed to check cart'
    };
    this.init();
  }

  // 英語ページかどうかを判定（2025-12-04追加）
  isEnglish() {
    return window.location.pathname.startsWith('/en/') ||
           window.location.pathname === '/en' ||
           (window.Shopify && window.Shopify.locale === 'en');
  }

  // 翻訳メッセージを取得（2025-12-04追加）
  t(message) {
    if (this.isEnglish() && this.translations[message]) {
      return this.translations[message];
    }
    return message;
  }

  init() {
    // 初期化フラグで重複実行を防ぐ
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    this.setupMobileMenu();
    this.setupFormValidation();
    this.setupVideoHover();
    this.setupFeaturedCollectionVideos();
    this.setupCardButtons();
    this.setupProductModal();
    this.initializeLikeStates();
    this.setupCollectionFilters();
    this.setupBadgeClasses();
    this.setupFiltersPanelPersistence(); // フィルターパネル状態保存
    this.setupInfiniteScroll(); // 無限スクロール実装
    this.setupTooltips(); // ツールチップ機能（2025-11-29追加）
  }

  // ツールチップ機能（position: fixedで親要素のoverflow:hiddenを回避）
  setupTooltips() {
    // モバイル・タッチデバイスではツールチップを無効化
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || window.innerWidth < 768) {
      return;
    }

    // ツールチップ要素を作成してbodyに追加
    let tooltip = document.getElementById('v0-global-tooltip');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.id = 'v0-global-tooltip';
      tooltip.style.cssText = `
        position: fixed;
        background: rgba(30, 30, 30, 0.95);
        color: #fff;
        padding: 6px 10px;
        border-radius: 6px;
        font-size: 11px;
        font-weight: 500;
        white-space: nowrap;
        pointer-events: none;
        z-index: 99999;
        opacity: 0;
        transform: translateY(-4px);
        transition: opacity 0.15s ease, transform 0.15s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      `;
      document.body.appendChild(tooltip);
    }

    // ホバー時にツールチップを表示
    const showTooltip = (e) => {
      const btn = e.currentTarget;
      const text = btn.getAttribute('data-tooltip');
      if (!text) return;

      tooltip.textContent = text;
      tooltip.style.opacity = '1';
      tooltip.style.transform = 'translateY(0)';

      // ボタンの位置を取得してツールチップを右下に配置（下のアイコンが隠れないように）
      const rect = btn.getBoundingClientRect();
      tooltip.style.top = `${rect.bottom + 4}px`;
      tooltip.style.left = `${rect.right + 4}px`;
    };

    // ホバー解除時にツールチップを非表示
    const hideTooltip = () => {
      tooltip.style.opacity = '0';
      tooltip.style.transform = 'translateY(-4px)';
    };

    // 既存ボタンにイベントリスナーを追加
    const attachTooltipListeners = () => {
      document.querySelectorAll('[data-tooltip]').forEach(btn => {
        if (btn.dataset.tooltipInitialized) return;
        btn.dataset.tooltipInitialized = 'true';
        btn.addEventListener('mouseenter', showTooltip);
        btn.addEventListener('mouseleave', hideTooltip);
      });
    };

    // 初回実行
    attachTooltipListeners();

    // 動的に追加される要素のためにMutationObserverを使用
    const observer = new MutationObserver(() => {
      attachTooltipListeners();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  setupMobileMenu() {
    const menuBtn = document.querySelector('.v0-header__menu');
    // サイドバーを内部のv0-sidebarから取得
    const sidebarWrapper = document.querySelector('.vf-sidebar-wrapper');
    const sidebar = sidebarWrapper ? sidebarWrapper.querySelector('.v0-sidebar') : document.querySelector('.v0-sidebar');

    if (!menuBtn) {
      debugLog('Menu button not found');
      return;
    }

    if (!sidebar) {
      debugLog('Sidebar not found');
      return;
    }

    debugLog('Setting up mobile menu with sidebar:', sidebar.className);

    // Open/close sidebar when menu button is clicked
    menuBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      debugLog('Menu button clicked - toggling sidebar');
      sidebar.classList.toggle('v0-sidebar--mobile-open');

      // Add overlay element dynamically
      if (sidebar.classList.contains('v0-sidebar--mobile-open')) {
        debugLog('Opening sidebar...');
        const overlay = document.createElement('div');
        overlay.className = 'v0-sidebar-overlay';
        overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;';
        document.body.appendChild(overlay);

        // Close when overlay is clicked
        overlay.addEventListener('click', () => {
          debugLog('Overlay clicked - closing sidebar');
          sidebar.classList.remove('v0-sidebar--mobile-open');
          overlay.remove();
        });
      } else {
        debugLog('Closing sidebar...');
        const overlay = document.querySelector('.v0-sidebar-overlay');
        if (overlay) overlay.remove();
      }
    });
  }

  setupFormValidation() {
    const forms = document.querySelectorAll('form[data-validate]');

    forms.forEach(form => {
      form.addEventListener('submit', (e) => {
        const inputs = form.querySelectorAll('[required]');
        let valid = true;

        inputs.forEach(input => {
          if (!input.value.trim()) {
            valid = false;
            input.classList.add('error');
          } else {
            input.classList.remove('error');
          }
        });

        if (!valid) {
          e.preventDefault();
        }
      });
    });
  }

  setupVideoUnloading() {
    /**
     * 画面外の動画をアンロード（メモリ節約）
     * - ビューポート外に出た動画: pause + src削除
     * - 画面内に戻った動画: src再設定
     * - Expected: メモリ削減 40%、スクロール 60fps維持
     */
    const unloadObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;

        if (!entry.isIntersecting) {
          // 画面外に出たら動画をアンロード（ソースを退避しておく）
          const sourceEl = video.querySelector('source');
          let storedSrc =
            video.dataset.videoSrc ||
            video.getAttribute('data-video-src') ||
            (sourceEl && (sourceEl.src || sourceEl.dataset.src)) ||
            video.src;

          if (storedSrc) {
            video.dataset.videoSrc = storedSrc;
          }

          if (sourceEl) {
            if (!sourceEl.dataset.src && sourceEl.src) {
              sourceEl.dataset.src = sourceEl.src;
            }
            sourceEl.removeAttribute('src');
          }

          if (video.src && video.src !== '') {
            video.pause();
            video.removeAttribute('src');
          }

          delete video.dataset.loaded;
          video.load(); // Safari の再生不具合回避
          debugLog('[setupVideoUnloading] Unloaded video:', video.dataset.videoSrc);
        } else {
          // 画面内に戻ったら再読み込み（実際に再生するタイミングはensureVideoSourceで行う）
          const sourceEl = video.querySelector('source');
          const storedSrc =
            video.dataset.videoSrc ||
            video.getAttribute('data-video-src') ||
            (sourceEl && sourceEl.dataset.src);

          if (storedSrc && sourceEl && !sourceEl.src) {
            sourceEl.src = storedSrc;
          }

          debugLog('[setupVideoUnloading] Video back in view:', storedSrc);
        }
      });
    }, {
      rootMargin: '-200px'  // 200px画面外に出たらアンロード
    });

    // 13個目以降の動画のみを監視（Above the Fold以外）
    const videos = Array.from(document.querySelectorAll('video[data-lazy-load="true"]'));
    videos.forEach(video => {
      unloadObserver.observe(video);
    });

    return unloadObserver;
  }

  setupVideoHover() {
    // ビデオホバー再生機能（改善版）
    const cards = document.querySelectorAll('.v0-card');
    debugLog('Setting up video hover for', cards.length, 'cards');

    // Lazy Loading強化版: メモリ管理フローを追加
    this.setupVideoUnloading();

    // ホバー時のみ読み込みに最適化
    // 動画はホバー時にのみ読み込まれる（以下のmouseenterイベントで処理）

    cards.forEach((card, index) => {
      // IntersectionObserverは無効化済み（パフォーマンス最適化）
      // 既にイベントが設定されている場合はスキップ
      if (card.dataset.videoInitialized) return;
      card.dataset.videoInitialized = 'true';

      const video = card.querySelector('.v0-card__video');
      const thumbnail = card.querySelector('.v0-card__thumbnail, .v0-card__image');

      if (!video) {
        debugLog('Card', index, 'has no video element');
        return;
      }

      // video要素のsourceを確認
      const initialSourceEl = video.querySelector('source');
      const initialSrc =
        (initialSourceEl && (initialSourceEl.dataset.src || initialSourceEl.src)) ||
        card.dataset.preview ||
        video.dataset.videoSrc ||
        video.getAttribute('data-video-src');
      if (initialSrc && !video.dataset.videoSrc) {
        video.dataset.videoSrc = initialSrc;
      }
      if (initialSourceEl && initialSourceEl.type && !video.dataset.mimeType) {
        video.dataset.mimeType = initialSourceEl.type;
      }
      if (initialSourceEl) {
        debugLog('Card', index, 'video placeholder URL:', initialSrc);
      }

      // 再生状態を管理
      let playPromise = null;
      let autoStopTimeout = null; // モバイル用5秒自動停止タイマー

      // 🔧 共通関数: 動画ソースを確実に初期化
      function ensureVideoSource() {
        const source = video.querySelector('source');
        // ★ 2025-11-28修正: source.srcがページURLの場合は無効とみなす
        const isValidVideoSrc = (src) => {
          if (!src) return false;
          // ページURLまたは空のsrcは無効
          if (src === window.location.href || src === window.location.origin + '/') return false;
          // 動画ファイルの拡張子またはCDNドメインをチェック
          return src.includes('.mp4') || src.includes('.webm') || src.includes('cdn.verticaly.co');
        };
        let candidateSrc =
          (source && isValidVideoSrc(source.src) && source.src) ||
          (source && source.dataset.src) ||
          video.dataset.videoSrc ||
          video.getAttribute('data-video-src') ||
          card.dataset.preview;

        if (!candidateSrc) {
          console.error('[ensureVideoSource] No video source found for card', index);
          return false;
        }

        // iOS再生制限対策で属性を毎回明示
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', 'true');
        video.setAttribute('webkit-playsinline', 'true');
        video.preload = 'auto';

        // 初回だけsrcをセット
        if (source) {
          if (!source.dataset.src) {
            source.dataset.src = candidateSrc;
          }
          if (!source.src) {
            source.src = candidateSrc;
            debugLog('[ensureVideoSource] Set source.src for card', index);
          }
        }

        if (!video.dataset.videoSrc) {
          video.dataset.videoSrc = candidateSrc;
        }

        if (!video.src) {
          video.src = candidateSrc;
          debugLog('[ensureVideoSource] Set video.src for card', index);
        }

        // まだ未読み込みなら load() は一度だけ
        if (!video.dataset.loaded) {
          video.load();
          video.dataset.loaded = 'true';
          debugLog('[ensureVideoSource] Called video.load() for card', index);
        }

        return true;
      }

      // ホバー時に動画を再生
      card.addEventListener('mouseenter', () => {
        debugLog('Mouse enter on card', index);

        // 🔧 動画ソースを確実に初期化
        if (!ensureVideoSource()) {
          debugLog('[mouseenter] ensureVideoSource failed for card', index);
          return;
        }

        // アクションボタンを確実に表示するためのクラスを追加
        card.classList.add('show-actions');

        // アクションボタンを強制的に表示（念のため）
        const actions = card.querySelector('.v0-card__actions');
        if (actions) {
          actions.style.setProperty('opacity', '1', 'important');
          actions.style.setProperty('visibility', 'visible', 'important');
          actions.style.setProperty('display', 'flex', 'important');
          actions.style.setProperty('z-index', '20', 'important'); // 動画より上に
        }

        // アクションボタンが動画の上に来るように再度確認
        const actionsAgain = card.querySelector('.v0-card__actions');
        if (actionsAgain) {
          actionsAgain.style.setProperty('z-index', '20', 'important');
        }

        // 🔧 loadeddata/canplayを待ってから再生
        const tryPlay = () => {
          // サムネイルをフェードアウト
          if (thumbnail) {
            thumbnail.style.opacity = '0';
            thumbnail.style.transition = 'opacity 0.3s ease';
          }

          // ビデオを表示
          video.style.display = 'block';
          video.style.opacity = '1';
          video.style.transition = 'opacity 0.3s ease';
          video.style.zIndex = '10';

          // 前の再生プロミスがあれば待つ
          if (playPromise) {
            playPromise.then(() => {
              video.currentTime = 0;
              playPromise = video.play();
              playPromise.catch(err => {
                console.error('[mouseenter] Video play failed:', err.name, err.message);
              });
            });
          } else {
            video.currentTime = 0;
            playPromise = video.play();
            playPromise.catch(err => {
              console.error('[mouseenter] Video play failed:', err.name, err.message);
            });
          }
        };

        // loadeddata待ちまたは即座に再生
        if (video.readyState >= 2) { // HAVE_CURRENT_DATA以上
          tryPlay();
        } else {
          video.addEventListener('loadeddata', tryPlay, { once: true });
        }
      });

      // ホバー終了時に動画を停止 & メモリ解放
      card.addEventListener('mouseleave', () => {
        debugLog('Mouse leave on card', index);

        // アクションボタンを非表示にするためクラスを削除
        card.classList.remove('show-actions');

        // アクションボタンのスタイルをリセット
        const actions = card.querySelector('.v0-card__actions');
        if (actions) {
          actions.style.removeProperty('opacity');
          actions.style.removeProperty('visibility');
          actions.style.removeProperty('display');
        }

        // 再生プロミスを待ってからメモリ解放
        const releaseVideo = () => {
          video.pause();
          // ★ 2025-11-28修正: removeAttributeを使用（空文字だとページURLに解決されてしまう）
          const source = video.querySelector('source');
          if (source) {
            // data-srcに元のURLを保存（まだなければ）
            if (source.src && !source.dataset.src) {
              source.dataset.src = source.src;
            }
            source.removeAttribute('src');
          }
          // video要素のsrcもremoveAttributeで削除
          video.removeAttribute('src');
          video.load();
          // loaded フラグをリセットして次回ホバーで再ロード可能に
          video.dataset.loaded = '';
          playPromise = null;
        };

        if (playPromise) {
          playPromise.then(releaseVideo).catch(releaseVideo);
        } else {
          releaseVideo();
        }

        // ビデオを非表示
        video.style.opacity = '0';
        setTimeout(() => {
          video.style.display = 'none';
        }, 300);

        // サムネイルをフェードイン
        if (thumbnail) {
          thumbnail.style.opacity = '1';
        }
      });

      // モバイル用: タッチ開始時に動画を再生
      card.addEventListener('touchstart', (e) => {
        debugLog('Touch start on card', index);

        // ボタンタップは除外（イベント伝播を防ぐ）
        if (e.target.closest('.v0-card__btn')) {
          return;
        }

        const currentState = card.dataset.videoPlaying;
        // 既に再生中であれば第二タップとして扱い、モーダル用タイムスタンプだけ更新
        if (currentState === 'playing') {
          card.dataset.modalArmedAt = String(Date.now());
          return;
        }
        card.dataset.videoPlaying = 'starting';
        card.dataset.modalArmedAt = String(Date.now());

        // 🔧 動画ソースを確実に初期化
        if (!ensureVideoSource()) {
          debugLog('[touchstart] ensureVideoSource failed for card', index);
          delete card.dataset.videoPlaying;
          delete card.dataset.modalArmedAt;
          return;
        }

        // アクションボタンを確実に表示するためのクラスを追加
        card.classList.add('show-actions');

        // アクションボタンを強制的に表示
        const actions = card.querySelector('.v0-card__actions');
        if (actions) {
          actions.style.setProperty('opacity', '1', 'important');
          actions.style.setProperty('visibility', 'visible', 'important');
          actions.style.setProperty('display', 'flex', 'important');
          actions.style.setProperty('z-index', '20', 'important');
        }

        // アクションボタンが動画の上に来るように再度確認
        const actionsAgain = card.querySelector('.v0-card__actions');
        if (actionsAgain) {
          actionsAgain.style.setProperty('z-index', '20', 'important');
        }

        // 🔧 loadeddata/canplayを待ってから再生（iOS Safari対策）
        const tryPlay = () => {
          // サムネイルをフェードアウト
          if (thumbnail) {
            thumbnail.style.opacity = '0';
            thumbnail.style.transition = 'opacity 0.3s ease';
          }

          // ビデオを表示
          video.style.display = 'block';
          video.style.opacity = '1';
          video.style.transition = 'opacity 0.3s ease';
          video.style.zIndex = '10';

          const markSuccess = () => {
            card.dataset.videoPlaying = 'playing';
            card.dataset.modalArmedAt = String(Date.now());
          };

          const markFailure = (err) => {
            console.error('[touchstart] Video play failed:', err.name, err.message);
            delete card.dataset.videoPlaying;
            delete card.dataset.modalArmedAt;
          };

          // 前の再生プロミスがあれば待つ
          if (playPromise) {
            playPromise.then(() => {
              video.currentTime = 0;
              playPromise = video.play();
              playPromise.then(() => {
                markSuccess();
              }).catch(markFailure);
            });
          } else {
            video.currentTime = 0;
            playPromise = video.play();
            playPromise.then(() => {
              markSuccess();
            }).catch(markFailure);
          }
        };

        // loadeddata待ちまたは即座に再生
        if (video.readyState >= 2) { // HAVE_CURRENT_DATA以上
          tryPlay();
        } else {
          video.addEventListener('loadeddata', tryPlay, { once: true });
        }

        // 既存の自動停止タイマーをクリア
        if (autoStopTimeout) {
          clearTimeout(autoStopTimeout);
        }

        // 5秒後に動画を自動停止
        autoStopTimeout = setTimeout(() => {
          debugLog('Auto-stop video after 5 seconds (touch)', index);

          // アクションボタンを非表示にする
          card.classList.remove('show-actions');
          const actions = card.querySelector('.v0-card__actions');
          if (actions) {
            actions.style.removeProperty('opacity');
            actions.style.removeProperty('visibility');
            actions.style.removeProperty('display');
          }

          // 動画を停止
          if (playPromise) {
            playPromise.then(() => {
              video.pause();
              playPromise = null;
            }).catch(() => {
              playPromise = null;
            });
          } else {
            video.pause();
          }

          // 🔧 videoPlayingフラグを削除（再タップで復帰可能に）
          delete card.dataset.videoPlaying;
          delete card.dataset.modalArmedAt;

          // ビデオを非表示
          video.style.opacity = '0';
          setTimeout(() => {
            video.style.display = 'none';
          }, 300);

          // サムネイルをフェードイン
          if (thumbnail) {
            thumbnail.style.opacity = '1';
          }

          // 動画再生フラグをリセット
          delete card.dataset.videoPlaying;
        }, 5000);
      });

      // モバイル用: タッチ終了時に動画を停止（500msの遅延で）
      let touchEndTimeout = null;
      card.addEventListener('touchend', (e) => {
        debugLog('Touch end on card', index);

        // ボタンタップは除外
        if (e.target.closest('.v0-card__btn')) {
          return;
        }

        // タッチ終了から500ms後に停止（誤タップ防止）
        if (touchEndTimeout) {
          clearTimeout(touchEndTimeout);
        }

        // 5秒自動停止タイマーもクリア
        if (autoStopTimeout) {
          clearTimeout(autoStopTimeout);
        }

        touchEndTimeout = setTimeout(() => {
          const state = card.dataset.videoPlaying;
          // 動画が再生準備中/再生中の場合は停止しない（5秒自動停止タイマーに任せる）
          if (state === 'starting' || state === 'playing') {
            debugLog('Video is playing, skip touchend timeout (let 5sec auto-stop handle it)', index);
            return;
          }

          // アクションボタンを非表示にするためクラスを削除
          card.classList.remove('show-actions');

          // アクションボタンのスタイルをリセット
          const actions = card.querySelector('.v0-card__actions');
          if (actions) {
            actions.style.removeProperty('opacity');
            actions.style.removeProperty('visibility');
            actions.style.removeProperty('display');
          }

          // 再生プロミスを待ってから停止
          if (playPromise) {
            playPromise.then(() => {
              video.pause();
              playPromise = null;
            }).catch(() => {
              playPromise = null;
            });
          } else {
            video.pause();
          }

          // ビデオを非表示
          video.style.opacity = '0';
          setTimeout(() => {
            video.style.display = 'none';
          }, 300);

          // サムネイルをフェードイン
          if (thumbnail) {
            thumbnail.style.opacity = '1';
          }

          // 動画再生フラグをリセット
          delete card.dataset.videoPlaying;
          delete card.dataset.modalArmedAt;
        }, 500);
      });
    });
  }

  setupFeaturedCollectionVideos() {
    const videos = document.querySelectorAll('.v0-featured-collection__video video');
    if (videos.length === 0) return;

    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;

      const maxAttempts = 5;
      let attempts = 0;

      const tryPlay = () => {
        attempts += 1;
        const playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch((err) => {
            debugLog('[setupFeaturedCollectionVideos] play failed', err.name, err.message, 'attempt', attempts);
            if (attempts < maxAttempts) {
              setTimeout(() => {
                video.load();
                tryPlay();
              }, 500);
            } else {
            }
          });
        }
      };

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener('loadeddata', tryPlay, { once: true });
        video.load();
      }
    });
  }

  setupCardButtons() {
    // カードのボタン機能を設定
    const buttons = document.querySelectorAll('.v0-card__btn');

    buttons.forEach(button => {
      // 既にイベントが設定されている場合はスキップ
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';

      button.addEventListener('click', (e) => {
        const action = button.dataset.action;

        // download-with-creditの場合は委譲ハンドラーに任せるためstopPropagationしない
        if (action !== 'download-with-credit') {
          e.stopPropagation(); // カードクリックイベントの伝播を防ぐ
        }

        const card = button.closest('.v0-card');
        const productId = card.dataset.productId;
        const variantId = card.dataset.variantId;
        const productTitle = card.dataset.title;

        switch (action) {
          case 'like':
            // いいね機能（ボタンを渡す）
            this.handleLike(productId, productTitle, button);
            break;

          case 'share':
            // シェア機能（ボタンを渡す）
            this.handleShare(productId, productTitle, button);
            break;

          case 'cart':
            // カートに追加機能
            this.handleAddToCart(variantId, productTitle);
            break;

          case 'download':
            // ダウンロード機能は専用ハンドラーに委譲
            if (window.V0Download && window.V0Download.handleDownload) {
              window.V0Download.handleDownload(button);
            }
            break;

          // download-with-creditはセクションの委譲ハンドラーに任せる
          // (stopPropagationしないためイベントがバブリングしてセクション側で処理される)
        }
      });
    });
  }

  setupInfiniteScroll() {
    // Load More ボタン方式の実装（最大2回まで、その後はページネーション）
    const grid = document.querySelector('.v0-grid');
    const trigger = document.querySelector('.v0-infinite-scroll-trigger');

    if (!grid || !trigger) {
      return;
    }

    const MAX_LOADS = 2; // 最大ロード回数
    let loadCount = 0;
    let isLoading = false;
    let nextUrl = trigger.dataset.nextUrl;
    let currentPage = parseInt(trigger.dataset.currentPage) || 1;
    const totalPages = parseInt(trigger.dataset.totalPages) || 1;
    const startPage = currentPage; // 開始ページを記録
    const isLastPage = !nextUrl && totalPages > 1;
    const isDirectAccess = currentPage > 1; // 直接ページにアクセスした場合

    // 1ページしかない場合は何も表示しない
    if (totalPages <= 1) return;

    // スタイル追加
    if (!document.getElementById('v0-loadmore-style')) {
      const style = document.createElement('style');
      style.id = 'v0-loadmore-style';
      style.textContent = `
        .v0-loadmore-container {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          padding: 40px 0;
          grid-column: 1 / -1;
        }
        .v0-loadmore-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 16px 48px;
          background-color: rgba(0, 0, 0, 0.6);
          border: 1px solid #00F0FF;
          border-radius: 50px;
          color: #00F0FF;
          font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
          font-weight: 700;
          font-size: 14px;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
          box-shadow: 0 0 10px rgba(0, 240, 255, 0.1);
          overflow: hidden;
        }
        .v0-loadmore-btn:hover {
          background-color: #00F0FF;
          color: #000000;
          box-shadow: 0 0 30px rgba(0, 240, 255, 0.6);
          transform: translateY(-2px);
        }
        .v0-loadmore-btn:active {
          transform: scale(0.95);
        }
        .v0-loadmore-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }
        .v0-loadmore-btn.loading {
          background-color: rgba(0, 240, 255, 0.1);
          border-color: rgba(0, 240, 255, 0.5);
          color: #00F0FF;
        }
        .v0-loadmore-info {
          display: block;
          margin-top: 12px;
          font-family: 'Space Grotesk', monospace, -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 11px;
          color: rgba(255, 255, 255, 0.4);
          letter-spacing: 0.15em;
        }
        .v0-loadmore-info .v0-page-num {
          color: #00F0FF;
        }
        .v0-spinner-ring {
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: middle;
          margin-right: 8px;
        }
        .v0-spinner-ring:after {
          content: " ";
          display: block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 2px solid #fff;
          border-color: #fff transparent #fff transparent;
          animation: v0-ring 1.2s linear infinite;
        }
        @keyframes v0-ring {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        /* ページネーションスタイル */
        .v0-pagination-container {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
          padding: 40px 0;
          grid-column: 1 / -1;
        }
        .v0-loadmore-complete {
          font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 14px;
          color: #00F0FF;
          letter-spacing: 0.05em;
          margin-bottom: 16px;
          padding: 12px 24px;
          background: rgba(0, 240, 255, 0.1);
          border: 1px solid rgba(0, 240, 255, 0.3);
          border-radius: 8px;
        }
        .v0-pagination-notice {
          font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.5);
          letter-spacing: 0.1em;
          margin-bottom: 8px;
        }
        .v0-pagination-list {
          display: flex;
          align-items: center;
          gap: 8px;
          list-style: none;
          padding: 0;
          margin: 0;
          flex-wrap: wrap;
          justify-content: center;
        }
        .v0-pagination-item {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 40px;
          height: 40px;
          padding: 0 12px;
          font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 14px;
          font-weight: 500;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.2s ease;
        }
        .v0-pagination-item--link {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: rgba(255, 255, 255, 0.7);
          cursor: pointer;
        }
        .v0-pagination-item--link:hover {
          background: rgba(0, 240, 255, 0.1);
          border-color: #00F0FF;
          color: #00F0FF;
          transform: translateY(-2px);
        }
        .v0-pagination-item--current {
          background: #00F0FF;
          border: 1px solid #00F0FF;
          color: #000;
          font-weight: 700;
        }
        .v0-pagination-item--dots {
          background: transparent;
          border: none;
          color: rgba(255, 255, 255, 0.3);
          min-width: 30px;
          cursor: default;
        }
        .v0-pagination-item--arrow {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: rgba(255, 255, 255, 0.7);
          cursor: pointer;
        }
        .v0-pagination-item--arrow:hover {
          background: rgba(0, 240, 255, 0.1);
          border-color: #00F0FF;
          color: #00F0FF;
        }
        .v0-pagination-item--arrow svg {
          width: 18px;
          height: 18px;
        }
        .v0-pagination-info {
          font-family: 'Space Grotesk', monospace, -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 11px;
          color: rgba(255, 255, 255, 0.4);
          letter-spacing: 0.15em;
        }
        .v0-pagination-info .v0-page-range {
          color: #00F0FF;
        }
        @media (max-width: 768px) {
          .v0-pagination-item {
            min-width: 36px;
            height: 36px;
            font-size: 13px;
          }
          .v0-pagination-list {
            gap: 6px;
          }
        }
      `;
      document.head.appendChild(style);
    }

    // Load More ボタンコンテナ作成
    const container = document.createElement('div');
    container.className = 'v0-loadmore-container';

    const loadMoreBtn = document.createElement('button');
    loadMoreBtn.className = 'v0-loadmore-btn';
    loadMoreBtn.textContent = 'LOAD MORE';

    const infoText = document.createElement('div');
    infoText.className = 'v0-loadmore-info';
    const padPage = (n) => String(n).padStart(2, '0');
    infoText.innerHTML = `PAGE <span class="v0-page-num">${padPage(currentPage)}</span> // ${padPage(totalPages)}`;

    container.appendChild(loadMoreBtn);
    container.appendChild(infoText);
    grid.parentNode.insertBefore(container, grid.nextSibling);

    // ページネーションを生成する関数
    const showPagination = (isComplete = false) => {
      // 現在のベースURLを構築
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      const baseUrl = url.toString();
      const separator = baseUrl.includes('?') ? '&' : '?';

      // 完了メッセージ（最後のページに到達した場合）
      const completeMessage = isComplete
        ? `<div class="v0-loadmore-complete">すべて読み込みました ✓</div>`
        : '';

      // 通知メッセージ
      const noticeText = isComplete
        ? `PAGE ${startPage}〜${currentPage} を表示中 // 他のページを選択してください`
        : `PAGE ${startPage}〜${currentPage} を表示中 // 続きはページを選択してください`;

      // ページネーションHTMLを生成
      let paginationHtml = `
        <div class="v0-pagination-container">
          ${completeMessage}
          <div class="v0-pagination-notice">${noticeText}</div>
          <ul class="v0-pagination-list">
      `;

      // 前へボタン
      if (currentPage > 1) {
        const prevPage = currentPage - 1;
        const prevUrl = prevPage === 1 ? baseUrl : `${baseUrl}${separator}page=${prevPage}`;
        paginationHtml += `
          <li>
            <a href="${prevUrl}" class="v0-pagination-item v0-pagination-item--arrow" aria-label="前のページ">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 18L9 12L15 6"/>
              </svg>
            </a>
          </li>
        `;
      }

      // ページ番号を生成
      const maxVisible = 9;
      let pagesToShow = [];

      if (isComplete) {
        // 完了時（最終ページ）: 全ページを表示対象にする
        if (totalPages <= maxVisible) {
          // 全ページ表示
          for (let i = 1; i <= totalPages; i++) {
            pagesToShow.push(i);
          }
        } else {
          // 省略表示（現在のページを中心に表示）
          const halfWindow = Math.floor(maxVisible / 2);
          let rangeStart = Math.max(1, currentPage - halfWindow);
          let rangeEnd = Math.min(totalPages, currentPage + halfWindow);

          // 範囲調整
          if (rangeStart === 1) {
            rangeEnd = Math.min(totalPages, maxVisible);
          }
          if (rangeEnd === totalPages) {
            rangeStart = Math.max(1, totalPages - maxVisible + 1);
          }

          // 先頭
          if (rangeStart > 1) {
            pagesToShow.push(1);
            if (rangeStart > 2) pagesToShow.push('...');
          }

          // 中央のページ群
          for (let i = rangeStart; i <= rangeEnd; i++) {
            if (!pagesToShow.includes(i)) pagesToShow.push(i);
          }

          // 末尾
          if (rangeEnd < totalPages) {
            if (rangeEnd < totalPages - 1) pagesToShow.push('...');
            if (!pagesToShow.includes(totalPages)) pagesToShow.push(totalPages);
          }
        }
      } else {
        // 継続時: 次のページから表示
        const nextPageStart = currentPage + 1;
        if (totalPages <= maxVisible + 2) {
          for (let i = nextPageStart; i <= totalPages; i++) {
            pagesToShow.push(i);
          }
        } else {
          const endFirstGroup = Math.min(nextPageStart + 2, totalPages);
          for (let i = nextPageStart; i <= endFirstGroup; i++) {
            pagesToShow.push(i);
          }
          if (endFirstGroup < totalPages - 2) {
            pagesToShow.push('...');
          }
          const startLastGroup = Math.max(totalPages - 1, endFirstGroup + 1);
          for (let i = startLastGroup; i <= totalPages; i++) {
            if (!pagesToShow.includes(i)) {
              pagesToShow.push(i);
            }
          }
        }
      }

      pagesToShow.forEach(page => {
        if (page === '...') {
          paginationHtml += `<li><span class="v0-pagination-item v0-pagination-item--dots">...</span></li>`;
        } else if (page === currentPage) {
          // 現在のページはハイライト表示（リンクなし）
          paginationHtml += `
            <li>
              <span class="v0-pagination-item v0-pagination-item--current">${page}</span>
            </li>
          `;
        } else {
          const pageUrl = page === 1 ? baseUrl : `${baseUrl}${separator}page=${page}`;
          paginationHtml += `
            <li>
              <a href="${pageUrl}" class="v0-pagination-item v0-pagination-item--link">${page}</a>
            </li>
          `;
        }
      });

      // 次へボタン
      if (currentPage < totalPages) {
        const nextPage = currentPage + 1;
        const nextPageUrl = `${baseUrl}${separator}page=${nextPage}`;
        paginationHtml += `
          <li>
            <a href="${nextPageUrl}" class="v0-pagination-item v0-pagination-item--arrow" aria-label="次のページ">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 18L15 12L9 6"/>
              </svg>
            </a>
          </li>
        `;
      }

      paginationHtml += `
          </ul>
          <div class="v0-pagination-info">SHOWING PAGES <span class="v0-page-range">${padPage(startPage)}-${padPage(currentPage)}</span> // ${padPage(totalPages)} TOTAL</div>
        </div>
      `;

      container.outerHTML = paginationHtml;
    };

    const loadMore = async () => {
      if (isLoading || !nextUrl) return;
      isLoading = true;

      // ボタンをローディング状態に
      loadMoreBtn.disabled = true;
      loadMoreBtn.classList.add('loading');
      loadMoreBtn.innerHTML = '<div class="v0-spinner-ring"></div>LOADING...';

      try {
        const response = await fetch(nextUrl);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        const newCards = doc.querySelectorAll('.v0-grid .v0-card');

        // 新しいトリガーから次のURLを取得
        const newTrigger = doc.querySelector('.v0-infinite-scroll-trigger');
        if (newTrigger && newTrigger.dataset.nextUrl) {
          nextUrl = newTrigger.dataset.nextUrl;
          currentPage = parseInt(newTrigger.dataset.currentPage) || currentPage + 1;
          infoText.innerHTML = `PAGE <span class="v0-page-num">${padPage(currentPage)}</span> // ${padPage(totalPages)}`;
        } else {
          nextUrl = null;
        }

        // 新しいカードを追加
        newCards.forEach(card => {
          grid.appendChild(card);
          // フェードインアニメーション
          card.style.opacity = '0';
          card.style.transform = 'translateY(20px)';
          requestAnimationFrame(() => {
            card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          });
        });

        // 新しいカードのイベント設定
        this.setupVideoHover();
        this.setupCardButtons();
        this.setupProductModal(); // モーダルクリックイベントを追加

        // visibleProductsの更新
        if (window.updateVisibleProducts) {
          window.updateVisibleProducts();
        }

        // ロード回数をインクリメント
        loadCount++;

        // 次のページがない場合 → 完了メッセージ + ページネーション表示
        if (!nextUrl) {
          showPagination(true);
        }
        // 最大ロード回数に達した場合 → ページネーションに切り替え
        else if (loadCount >= MAX_LOADS) {
          showPagination();
        }

      } catch (error) {
        console.error('[Load More] Error:', error);
        loadMoreBtn.textContent = 'エラー - もう一度試す';
      } finally {
        isLoading = false;
        loadMoreBtn.disabled = false;
        loadMoreBtn.classList.remove('loading');
        if (nextUrl && loadCount < MAX_LOADS) {
          loadMoreBtn.textContent = 'LOAD MORE';
        }
      }
    };

    // 最終ページに直接アクセスした場合は、即座にページネーションを表示
    if (isLastPage) {
      // Load Moreボタンではなく、直接ページネーションを表示
      showPagination(true);
      return;
    }

    // ボタンクリックでロード
    loadMoreBtn.addEventListener('click', loadMore);
  }

  // Disabled implementation kept for reference
  setupInfiniteScrollDisabled() {
    const grid = document.querySelector('.v0-grid');
    // 複数のページネーションパターンに対応
    const pagination = document.querySelector('.v0-pagination') || document.querySelector('.pagination') || document.querySelector('nav[role="navigation"]');

    if (!grid) {
      console.error('[Infinite Scroll] Grid not found');
      return;
    }

    if (!pagination) {
      return;
    }

    // ページネーション要素を隠す
    pagination.style.display = 'none';

    let isLoading = false;
    // 次のページURLを取得（複数のセレクタを試行）
    const getNextUrl = () => {
      const nextLink = pagination.querySelector('.next a') ||
        pagination.querySelector('a[rel="next"]') ||
        pagination.querySelector('.pagination__next') ||
        pagination.querySelector('li:last-child a');
      return nextLink ? nextLink.href : null;
    };

    let nextUrl = getNextUrl();

    if (!nextUrl) return;

    const loadMore = async () => {
      if (isLoading || !nextUrl) return;
      isLoading = true;

      // ローディングインジケーター
      const loader = document.createElement('div');
      loader.className = 'v0-infinite-loader';
      loader.innerHTML = '<div class="v0-spinner-ring"></div>';
      loader.style.cssText = `
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 40px 0;
        grid-column: 1 / -1;
      `;
      // スピナーのスタイル追加
      if (!document.getElementById('v0-spinner-style')) {
        const style = document.createElement('style');
        style.id = 'v0-spinner-style';
        style.textContent = `
          .v0-spinner-ring {
            display: inline-block;
            width: 40px;
            height: 40px;
          }
          .v0-spinner-ring:after {
            content: " ";
            display: block;
            width: 32px;
            height: 32px;
            margin: 4px;
            border-radius: 50%;
            border: 3px solid #fff;
            border-color: #fff transparent #fff transparent;
            animation: v0-ring 1.2s linear infinite;
          }
          @keyframes v0-ring {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `;
        document.head.appendChild(style);
      }

      grid.appendChild(loader);

      try {
        const response = await fetch(nextUrl);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        const newCards = doc.querySelectorAll('.v0-grid .v0-card');

        // 新しいページネーションから次のURLを取得
        const newPagination = doc.querySelector('.v0-pagination') || doc.querySelector('.pagination') || doc.querySelector('nav[role="navigation"]');
        if (newPagination) {
          const newNextLink = newPagination.querySelector('.next a') ||
            newPagination.querySelector('a[rel="next"]') ||
            newPagination.querySelector('.pagination__next') ||
            newPagination.querySelector('li:last-child a');
          nextUrl = newNextLink ? newNextLink.href : null;
        } else {
          nextUrl = null;
        }

        // 新しいカードを追加
        newCards.forEach(card => {
          grid.appendChild(card);
          // アニメーション
          card.style.opacity = '0';
          card.style.transform = 'translateY(20px)';
          requestAnimationFrame(() => {
            card.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          });
        });

        // イベント再設定
        this.setupVideoHover();
        this.setupCardButtons();
        this.setupProductModal(); // モーダルクリックイベントを追加

        if (window.updateVisibleProducts) {
          window.updateVisibleProducts();
        }

      } catch (error) {
        console.error('[Infinite Scroll] Error:', error);
      } finally {
        isLoading = false;
        loader.remove();

        // センチネルを再配置（グリッドの最後へ）
        const sentinel = document.querySelector('.v0-scroll-sentinel');
        if (sentinel) {
          grid.appendChild(sentinel);
        }
      }
    };

    // 監視用のセンチネル要素を作成（高さを持たせる）
    const sentinel = document.createElement('div');
    sentinel.className = 'v0-scroll-sentinel';
    sentinel.style.cssText = 'width: 100%; height: 100px; grid-column: 1 / -1; pointer-events: none;';
    grid.appendChild(sentinel);

    // Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        loadMore();
      }
    }, {
      rootMargin: '600px' // 早めに読み込む
    });

    observer.observe(sentinel);
  }

  handleLike(productId, title, button) {
    // productIdを文字列として確実に処理
    const strProductId = String(productId);

    // LocalStorageからいいね情報を取得
    const storedLikes = JSON.parse(localStorage.getItem('productLikes') || '{}');
    const likedProductsV2 = JSON.parse(localStorage.getItem('v0_liked_products_v2') || '[]');

    // 商品のいいね情報を初期化（存在しない場合）
    if (!storedLikes[strProductId]) {
      storedLikes[strProductId] = { count: 0 };
    }

    // ユーザーが既にいいねしているかチェック（v0_liked_products_v2から判定）
    const existingIndex = likedProductsV2.findIndex(p => String(p.id) === strProductId);
    const isLiked = existingIndex !== -1;
    const icon = button?.querySelector('svg');

    if (isLiked) {
      // いいねを取り消し
      storedLikes[strProductId].count = Math.max(0, storedLikes[strProductId].count - 1);
      likedProductsV2.splice(existingIndex, 1);

      // アイコンのスタイルを更新（色をリセット）
      if (icon) {
        icon.setAttribute('fill', 'none');
        icon.style.color = '';
        // 親ボタンからもクラスを削除
        if (button) {
          button.classList.remove('v0-card__btn--liked');
        }
      }

      this.showNotification(this.t('お気に入りから削除しました'), 'warning');

      // favoriteRemovedイベントを発火
      document.dispatchEvent(new CustomEvent('favoriteRemoved', {
        detail: { productId: strProductId }
      }));
    } else {
      // いいねを追加
      storedLikes[strProductId].count += 1;

      // カードから商品データを取得
      const card = button.closest('.v0-card');
      const productData = this.getProductDataFromCard(card);

      // サムネイルURL生成（プレビュー動画URLから）
      const previewUrl = productData.preview_url || '';
      let thumbnailUrl = '';
      if (previewUrl) {
        thumbnailUrl = previewUrl
          .replace('/watermarked/', '/thumbs/')
          .replace('_preview.mp4', '_001.webp');
      }

      // AI生成フラグに基づいて正しい価格を計算
      // Boolean型（true）と文字列型（'true'）の両方に対応
      const isAiGenerated = card.dataset.aiGenerated === 'true' || productData.ai_generated === 'true' || productData.ai_generated === true;
      // Junkページの場合は0円、それ以外はAI判定
      const isJunkPage = window.location.pathname.includes('/collections/junk');
      const correctPrice = isJunkPage ? 0 : (isAiGenerated ? 200 : 500);

      // v0_liked_products_v2に追加（お気に入りページが期待する形式）
      likedProductsV2.unshift({
        id: productData.id,
        variantId: productData.variantId,
        preview: productData.preview_url,
        image: thumbnailUrl,
        thumbnail: thumbnailUrl,
        title: productData.title,
        price: correctPrice,
        description: productData.description,
        category: productData.category,
        productHandle: productData.handle,
        handle: productData.handle,
        tags: productData.tags,
        resolution: productData.resolution,
        duration_sec: productData.duration,
        duration: productData.duration,
        durationDisplay: productData.durationDisplay,
        fileSize: productData.fileSize,
        file_size: productData.fileSize,
        fileSizeDisplay: productData.fileSizeDisplay,
        file_size_display: productData.fileSizeDisplay,
        aspect_ratio: productData.aspectRatio,
        width: productData.width,
        height: productData.height,
        fps: productData.fps,
        person_gender: card.dataset.personGender || '',
        person_age_group: card.dataset.personAgeGroup || '',
        ai_generated: isAiGenerated,
        aiGenerated: isAiGenerated,
        aiTool: productData.ai_tool || card.dataset.aiTool || ''
      });

      // アイコンのスタイルを更新
      if (icon) {
        icon.setAttribute('fill', '#ef4444');
        icon.style.color = '#ef4444';
        // 親ボタンにクラスを追加
        if (button) {
          button.classList.add('v0-card__btn--liked');
        }
      }

      this.showNotification(this.t('お気に入りに追加しました'));

      // favoriteAddedイベントを発火
      document.dispatchEvent(new CustomEvent('favoriteAdded', {
        detail: { product: likedProductsV2[0] }
      }));
    }

    // LocalStorageを更新
    localStorage.setItem('productLikes', JSON.stringify(storedLikes));
    localStorage.setItem('v0_liked_products_v2', JSON.stringify(likedProductsV2));

    // モーダルが開いている場合はモーダルのいいね数も更新
    const modalLikesEl = document.querySelector('#v0ModalLikes');
    if (modalLikesEl && window.currentProductData?.id == strProductId) {
      modalLikesEl.textContent = storedLikes[strProductId].count.toLocaleString();
      const modalIcon = document.querySelector('#v0ModalLikeIcon');
      if (modalIcon) {
        // モーダルのアイコンも同期（isLikedの状態は既に反転しているので、逆にする）
        modalIcon.setAttribute('fill', !isLiked ? '#ef4444' : 'none');
        modalIcon.style.color = !isLiked ? '#ef4444' : 'currentColor';
      }
    }
  }

  handleShare(productId, title, button = null) {
    // シェア用URLを作成（モーダル自動表示パラメータ付き）
    // productIdが数値の場合はhandleを取得する必要がある
    const card = document.querySelector(`[data-product-id="${productId}"]`);
    let shareUrl;

    if (card && card.dataset.productHandle) {
      // ハンドルがある場合は使用
      shareUrl = `${window.location.origin}/products/${card.dataset.productHandle}?modal=true`;
    } else if (typeof productId === 'string' && !productId.match(/^\d+$/)) {
      // productIdが文字列でハンドルの場合
      shareUrl = `${window.location.origin}/products/${productId}?modal=true`;
    } else {
      // 数値IDの場合（フォールバック）
      shareUrl = `${window.location.origin}/products/${productId}?modal=true`;
    }

    // ボタンの視覚的フィードバック関数
    const showButtonFeedback = (btn) => {
      if (!btn) return;
      const originalIcon = btn.innerHTML;
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      btn.style.backgroundColor = '#10b981';
      setTimeout(() => {
        btn.innerHTML = originalIcon;
        btn.style.backgroundColor = '';
      }, 2000);
    };

    // クリップボードにコピー
    const copyToClipboard = async () => {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(shareUrl);
          this.showNotification(this.t('リンクをコピーしました'));
          showButtonFeedback(button);
          return true;
        }
      } catch (err) {
        // エラーログ削除（セキュリティ対策: 2025年12月3日）
      }

      // フォールバック: execCommand('copy')
      try {
        const textArea = document.createElement('textarea');
        textArea.value = shareUrl;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        textArea.style.top = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const success = document.execCommand('copy');
        document.body.removeChild(textArea);
        if (success) {
          this.showNotification(this.t('リンクをコピーしました'));
          showButtonFeedback(button);
          return true;
        }
      } catch (err) {
        // エラーログ削除（セキュリティ対策: 2025年12月3日）
      }

      // 両方失敗した場合
      this.showNotification(this.t('コピーに失敗しました'), 'error');
      return false;
    };

    copyToClipboard();
  }

  handleAddToCart(variantId, title) {
    // ダウンロード制限チェックは削除（通常の商品購入には不要）
    // サブスクリプションページ専用の機能のため、商品カードからは直接カートに追加可能

    // まず現在のカートをチェック
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const existingItem = cart.items.find(item => {
          return String(item.variant_id) === String(variantId);
        });

        if (existingItem) {
          // すでにカートに入っている場合はオレンジで警告（動画は1個しかダウンロードできない）
          this.showNotification(this.t('この商品はすでにカートに入っています。'), 'warning');
          return;
        }

        // カートに入っていない場合は追加（数量は常に1）
        const formData = {
          'items': [{
            'id': parseInt(variantId),
            'quantity': 1
          }]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('カートへの追加に失敗しました');
            }
            return response.json();
          })
          .then(data => {
            // 成功したら通知を表示
            this.showNotification(this.t('カートに追加しました'));

            // ダウンロード数をカウントアップ（サブスクリプション）
            if (window.DownloadLimitChecker && typeof window.DownloadLimitChecker.incrementDownloadCount === 'function') {
              window.DownloadLimitChecker.incrementDownloadCount();
            }

            // カートカウントを更新
            this.updateCartCount();
          })
          .catch(error => {
            console.error('カート追加エラー:', error);
            this.showNotification(this.t('カートへの追加に失敗しました'), 'error');
          });
      })
      .catch(error => {
        console.error('カートの確認に失敗しました:', error);
        this.showNotification(this.t('カートの確認に失敗しました'), 'error');
      });
  }

  updateCartCount() {
    // カートアイテム数を取得して更新
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // 複数のセレクタを試す（互換性のため）
        const cartCount = document.querySelector('#cart-count, .v0-header__cart-count, .cart-count');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          // カートアイテムがある場合は表示
          if (cart.item_count > 0) {
            cartCount.style.display = 'flex';
          }
        }
      });
  }

  initializeLikeStates() {
    // ページ読み込み時にいいね状態を初期化
    const likedProductsV2 = JSON.parse(localStorage.getItem('v0_liked_products_v2') || '[]');
    const likedProductIds = likedProductsV2.map(p => String(p.id));
    const cards = document.querySelectorAll('.v0-card');

    cards.forEach(card => {
      const productId = String(card.dataset.productId);
      const likeBtn = card.querySelector('[data-action="like"]');
      if (likeBtn) {
        if (likedProductIds.includes(productId)) {
          const icon = likeBtn.querySelector('svg');
          if (icon) {
            icon.setAttribute('fill', '#ef4444');
            icon.style.color = '#ef4444';
          }
          likeBtn.classList.add('v0-card__btn--liked');
        } else {
          // いいねしていない場合は確実にリセット
          const icon = likeBtn.querySelector('svg');
          if (icon) {
            icon.setAttribute('fill', 'none');
            icon.style.color = '';
          }
          likeBtn.classList.remove('v0-card__btn--liked');
        }
      }
    });
  }

  setupCollectionFilters() {
    // コレクションページのフィルター機能
    // すべてのフィルター入力要素を取得（HTMLのname属性に合わせて修正）
    const filterInputs = document.querySelectorAll('[data-filter], input[name="content-type"], input[name="person-gender"], input[name="person-age"], input[name="duration"], input[name="resolution"], input[name="ai-tool"]');
    if (filterInputs.length === 0) return;

    // フィルターの変更を監視
    filterInputs.forEach(input => {
      input.addEventListener('change', () => this.applyFilters());
    });

    // 初期状態でフィルターを適用
    this.applyFilters();
  }

  applyFilters() {
    const cards = document.querySelectorAll('.v0-card');
    if (cards.length === 0) return;

    // 現在のフィルター設定を取得（HTMLのname属性に合わせて修正）
    const filters = {
      contentType: document.querySelector('input[name="content-type"]:checked')?.value || 'all',
      gender: document.querySelector('input[name="person-gender"]:checked')?.value || 'all',
      age: document.querySelector('input[name="person-age"]:checked')?.value || 'all',
      duration: document.querySelector('input[name="duration"]:checked')?.value || 'all',
      resolution: document.querySelector('input[name="resolution"]:checked')?.value || 'all',
      aiTool: document.querySelector('input[name="ai-tool"]:checked')?.value || 'all'
    };

    // フィルター状態を保存（モーダルナビゲーションで使用）
    this.currentFilters = filters;

    let visibleCount = 0;
    let hiddenCount = 0;

    cards.forEach(card => {
      let shouldShow = true;

      // コンテンツタイプフィルター
      const isAI = card.dataset.aiGenerated === 'true';
      if (filters.contentType === 'ai' && !isAI) shouldShow = false;
      if (filters.contentType === 'real' && isAI) shouldShow = false;

      // 人物性別フィルター（person_genderメタフィールドを使用）
      if (filters.gender !== 'all' && shouldShow) {
        const gender = card.dataset.personGender || '';
        // メタフィールドがある場合の処理
        if (gender) {
          if (filters.gender === 'male' && gender !== 'male') shouldShow = false;
          if (filters.gender === 'female' && gender !== 'female') shouldShow = false;
          if (filters.gender === 'none' && gender !== 'none') shouldShow = false;
        } else {
          // メタフィールドがない場合はタグから判定（後方互換性）
          const tags = card.dataset.tags || '';
          const hasGender = {
            male: tags.includes('男性') || tags.includes('男'),
            female: tags.includes('女性') || tags.includes('女'),
            none: !tags.includes('男性') && !tags.includes('男') && !tags.includes('女性') && !tags.includes('女')
          };

          if (filters.gender === 'male' && !hasGender.male) shouldShow = false;
          if (filters.gender === 'female' && !hasGender.female) shouldShow = false;
          if (filters.gender === 'none' && !hasGender.none) shouldShow = false;
        }
      }

      // 年代フィルター（person_age_groupメタフィールドを使用）
      if (filters.age !== 'all' && shouldShow) {
        const ageGroup = card.dataset.personAgeGroup || 'unknown';

        // HTMLフィルター値（10s, 20s, 30s等）とメタフィールド値が同じ形式なので直接比較
        if (ageGroup === 'unknown' || ageGroup === '' || ageGroup === null) {
          // 年代不明の動画は特定年代フィルターで非表示
          shouldShow = false;
        } else if (ageGroup !== filters.age) {
          // 年代が設定されているが、選択された年代と異なる場合も非表示
          shouldShow = false;
        }
      }

      // 動画の長さフィルター
      if (filters.duration !== 'all' && shouldShow) {
        const duration = parseFloat(card.dataset.duration) || 0;
        // HTMLフィルター値に合わせて修正: 'short', 'medium'
        if (filters.duration === 'short' && duration >= 10) shouldShow = false;
        if (filters.duration === 'medium' && duration < 10) shouldShow = false;
      }

      // 解像度フィルター
      if (filters.resolution !== 'all' && shouldShow) {
        const resolution = card.dataset.resolution || '';
        // HD: 720p or 1080p
        if (filters.resolution === 'HD' && resolution !== 'HD') shouldShow = false;
        // 4K: 2160p or higher
        if (filters.resolution === '4K' && resolution !== '4K') shouldShow = false;
        // SD: その他（HDでも4Kでもない）
        if (filters.resolution === 'SD' && (resolution === 'HD' || resolution === '4K')) shouldShow = false;
      }

      // AIツールフィルター（部分一致 + 大文字小文字無視）
      if (filters.aiTool !== 'all' && shouldShow) {
        const aiTool = card.dataset.aiTool || '';
        const isAI = card.dataset.aiGenerated === 'true';

        // AI生成でない動画は、AIツールフィルターで必ず非表示
        if (!isAI) {
          shouldShow = false;
        } else {
          // AI生成動画の場合、選択されたAIツールと部分一致する場合のみ表示（大文字小文字無視）
          const toolLower = aiTool.toLowerCase();
          const filterToolLower = filters.aiTool.toLowerCase();

          if (filters.aiTool === 'other') {
            // その他：主要ツール以外
            const mainTools = ['veo', 'midjourney', 'kling', 'sora'];
            if (mainTools.some(tool => toolLower.includes(tool))) {
              shouldShow = false;
            }
          } else {
            // 特定ツール：部分一致で判定
            if (!toolLower.includes(filterToolLower)) {
              shouldShow = false;
            }
          }
        }
      }

      // カードの表示/非表示を切り替え
      if (shouldShow) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
        hiddenCount++;
      }
    });

    debugLog(`Filters applied: ${visibleCount} visible, ${hiddenCount} hidden`);

    // visibleProducts配列を更新（モーダルナビゲーション用）
    if (typeof window.updateVisibleProducts === 'function') {
      window.updateVisibleProducts();
    }
  }

  setupProductModal() {
    // 商品モーダル機能（既存のopenProductModal関数を使用）
    const cards = document.querySelectorAll('.v0-card');


    // すべての商品データを配列として保持（スワイプ機能用）
    window.v0ProductsData = [];

    cards.forEach((card, index) => {
      // 既にイベントが設定されている場合はスキップ
      if (card.dataset.modalInitialized) {
        return;
      }
      card.dataset.modalInitialized = 'true';


      // 商品データを収集
      const productData = this.getProductDataFromCard(card);
      productData.index = index;
      window.v0ProductsData.push(productData);


      card.addEventListener('click', (e) => {
        // ボタンクリックは除外
        if (e.target.closest('.v0-card__btn')) return;

        e.preventDefault();
        e.stopPropagation();

        // すべてのデバイスでモーダルを開く（モバイル強制遷移を削除）
        window.currentProductIndex = index;

        if (window.openProductModal) {
          window.openProductModal(productData);
        } else {
          // フォールバック: 商品ページへ遷移
          window.location.href = `/products/${productData.handle}`;
        }
      });
    });
  }

  getProductDataFromCard(card) {
    // メタフィールドからタグを取得
    let tags = [];
    const tagsData = card.dataset.tags;

    if (tagsData) {
      try {
        // JSON形式でパース
        tags = JSON.parse(tagsData);
        debugLog('Tags from metafield:', tags);
      } catch (e) {
        // パース失敗時はカンマ区切りとして処理
        if (tagsData.includes(',')) {
          tags = tagsData.split(',').map(tag => tag.trim());
        } else if (tagsData) {
          tags = [tagsData];
        }
        debugLog('Tags parsed as string:', tags);
      }
    }

    // タグが空の場合はカテゴリベースのデフォルトタグを設定
    if (!tags || tags.length === 0) {
      const category = card.dataset.category;
      if (category === '美容・ファッション' || card.dataset.title?.includes('ヘア')) {
        tags = ['ヘアアレンジ', '美容', 'ファッション', '動画', '韓国風', 'ヘアスタイル', '女性', '自撮り'];
      } else if (category === '食事・料理') {
        tags = ['料理', 'レシピ', 'グルメ', '動画', '食事'];
      } else if (category === '風景・自然') {
        tags = ['風景', '自然', '絶景', '動画', '旅行'];
      } else {
        // デフォルトタグ
        tags = ['動画', '縦型', 'SNS', 'ショート'];
      }
      debugLog('Using fallback tags for category:', category, tags);
    }

    // AI生成フラグに基づいて正しい価格を計算
    const isAiGenerated = card.dataset.aiGenerated === 'true';
    // Junkページの場合は0円、それ以外はAI判定
    const isJunkPage = window.location.pathname.includes('/collections/junk');
    const correctPrice = isJunkPage ? 0 : (isAiGenerated ? 200 : 500);

    const productData = {
      id: card.dataset.productId,
      variantId: card.dataset.variantId, // variantIdを追加
      handle: card.dataset.productHandle,
      title: card.dataset.title,
      price: correctPrice, // 正しい価格を使用
      description: card.dataset.description,
      preview_url: card.dataset.preview,
      category: card.dataset.category || 'カテゴリー',
      ai_generated: card.dataset.aiGenerated, // スネークケース（モーダル用）
      aiGenerated: isAiGenerated, // キャメルケース（ナビゲーション用）
      ai_tool: card.dataset.aiTool, // スネークケース（モーダル用）
      aiTool: card.dataset.aiTool || '', // キャメルケース（ナビゲーション用）
      fileSize: card.dataset.fileSize || 0,
      fileSizeDisplay: card.dataset.fileSizeDisplay || '',
      duration: card.dataset.duration || 0,
      durationDisplay: card.dataset.durationDisplay || '',
      resolution: card.dataset.resolution || 'HD',
      aspectRatio: card.dataset.aspectRatio || '9:16',
      width: card.dataset.width,
      height: card.dataset.height,
      fps: card.dataset.fps,
      tags: tags
    };

    return productData;
  }

  setupBadgeClasses() {
    // AIバッジがあるカードにhas-ai-badgeクラスを追加
    const cards = document.querySelectorAll('.v0-card');

    // Glitch Reveal: 画像読み込み監視
    const thumbnails = document.querySelectorAll('.v0-card__thumbnail:not(.loaded)');
    thumbnails.forEach(img => {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', () => {
          img.classList.add('loaded');
        });
      }
    });

    cards.forEach((card, index) => {
      const aiBadge = card.querySelector('.v0-card__ai-badge');
      if (aiBadge) {
        card.classList.add('has-ai-badge');
      }
    });
  }

  showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `v0-notification v0-notification--${type}`;
    notification.textContent = message;

    // typeに応じて背景色を決定
    let backgroundColor;
    if (type === 'success') {
      backgroundColor = '#10b981';  // 緑色
    } else if (type === 'warning') {
      backgroundColor = '#fffbeb';  // 薄い黄色
    } else if (type === 'error') {
      backgroundColor = '#ef4444';  // 赤色
    } else {
      backgroundColor = '#3b82f6';  // 青色（info）
    }

    notification.style.background = backgroundColor;

    // モーダルが開いているかチェック
    const modal = document.querySelector('#v0-modal');
    const isModalOpen = modal && !modal.classList.contains('v0-modal--hidden');

    if (isModalOpen) {
      // モーダルが開いている場合は、モーダル内に通知を追加
      // 既存の通知があれば削除
      const existingNotification = modal.querySelector('.v0-notification');
      if (existingNotification) {
        existingNotification.remove();
      }
      // モーダルのダイアログ内に追加
      const modalDialog = modal.querySelector('.v0-modal__dialog');
      if (modalDialog) {
        modalDialog.appendChild(notification);
        // モーダル内での位置調整
        notification.style.position = 'absolute';
        notification.style.top = '20px';
        notification.style.right = '20px';
      }
    } else {
      // 通常通りbodyに追加
      document.body.appendChild(notification);
    }

    setTimeout(() => {
      notification.classList.add('v0-notification--show');
    }, 10);

    setTimeout(() => {
      notification.classList.remove('v0-notification--show');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }

  // フィルターパネルの状態を保存・復元する
  setupFiltersPanelPersistence() {
    const panel = document.getElementById('filters-panel');
    const toggleButton = document.querySelector('[onclick="toggleFilters()"]');

    if (!panel || !toggleButton) {
      return; // フィルターパネルが存在しないページではスキップ
    }


    // ページロード時に保存された状態を復元
    const savedState = sessionStorage.getItem('filtersPanelState');
    if (savedState === 'open') {
      panel.style.display = 'block';
    } else {
    }

    // toggleFilters関数をオーバーライド
    window.toggleFilters = () => {
      const isCurrentlyHidden = panel.style.display === 'none' || !panel.style.display;
      const newState = isCurrentlyHidden ? 'open' : 'closed';

      // 表示状態を切り替え
      panel.style.display = isCurrentlyHidden ? 'block' : 'none';

      // sessionStorageに状態を保存
      sessionStorage.setItem('filtersPanelState', newState);

    };
  }

  applyColorFilter(targetColor) {
    const cards = document.querySelectorAll('.v0-card');

    // カラーとタグのマッピング（8色パレット）
    const colorToTag = {
      '#ef4444': 'カラー:赤',
      '#3b82f6': 'カラー:青',
      '#10b981': 'カラー:緑',
      '#f59e0b': 'カラー:黄',
      '#8b5cf6': 'カラー:紫',
      '#ec4899': 'カラー:ピンク',
      '#000000': 'カラー:黒',
      '#ffffff': 'カラー:白'
    };

    let visibleCount = 0;
    let hiddenCount = 0;

    cards.forEach(card => {
      // 「全て」の場合は全て表示
      if (targetColor === 'all') {
        card.style.display = '';
        visibleCount++;
        return;
      }

      // 商品のタグを取得（data-tags属性から）
      const tags = card.dataset.tags || '';
      const targetTag = colorToTag[targetColor];

      // タグにカラー情報が含まれているかチェック
      if (targetTag && tags.includes(targetTag)) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
        hiddenCount++;
      }
    });

    // Theater Mode用の表示商品リストを更新
    window.visibleProducts = Array.from(cards)
      .filter(c => c.style.display !== 'none')
      .map(c => this.getProductDataFromCard(c));

  }

  // Theater Mode Logic
  setupTheaterMode() {
    // Theater pagination state
    const theaterState = {
      allProducts: [],
      currentPage: 0,
      itemsPerPage: 15, // 15件ずつ表示（3列 x 5行）
      isLoading: false,
      videoObserver: null
    };

    window.v0Theater = {
      open: () => {
        const modal = document.getElementById('v0TheaterModal');
        const feed = document.getElementById('v0TheaterFeed');
        if (!modal || !feed) return;

        modal.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Ensure Studio Controller is visible above Theater Mode
        const studioControls = document.querySelector('.v0-studio-controls');
        if (studioControls) {
          studioControls.style.zIndex = '2001'; // Theater modal is usually 2000
        }

        // Reset pagination state and populate feed
        try {
          theaterState.currentPage = 0;
          theaterState.allProducts = [];
          this.renderTheaterFeed(feed, theaterState);
        } catch (err) {
          console.error('[Theater] render failed', err);
          modal.classList.remove('active');
          document.body.style.overflow = '';
        }
      },
      close: () => {
        const modal = document.getElementById('v0TheaterModal');
        if (!modal) return;

        modal.classList.remove('active');
        document.body.style.overflow = '';

        // Reset Studio Controller z-index
        const studioControls = document.querySelector('.v0-studio-controls');
        if (studioControls) {
          studioControls.style.zIndex = '';
        }

        // Pause all videos in theater
        const videos = modal.querySelectorAll('video');
        videos.forEach(v => v.pause());

        // Disconnect observer
        if (theaterState.videoObserver) {
          theaterState.videoObserver.disconnect();
          theaterState.videoObserver = null;
        }
      },
      toggle: () => {
        const modal = document.getElementById('v0TheaterModal');
        if (modal && modal.classList.contains('active')) {
          window.v0Theater.close();
        } else {
          window.v0Theater.open();
        }
      },
      loadMore: () => {
        if (theaterState.isLoading) return;

        const feed = document.getElementById('v0TheaterFeed');
        if (!feed) return;

        theaterState.currentPage++;
        this.appendTheaterItems(feed, theaterState);
      }
    };
  }

  initializeVisibleProducts() {
    const cards = document.querySelectorAll('.v0-card');
    window.visibleProducts = Array.from(cards).map(c => this.getProductDataFromCard(c));
  }

  renderTheaterFeed(container, theaterState) {
    // Reset content each time to avoid duplicates and memory leaks
    container.innerHTML = '';

    // Get all products from the grid
    let products = window.visibleProducts || [];

    // Fallback: if no products in global state, scrape from DOM
    if (products.length === 0) {
      const cards = document.querySelectorAll('.v0-card');
      products = Array.from(cards).map(c => this.getProductDataFromCard(c));
    }

    // パフォーマンスのため200件に制限
    theaterState.allProducts = products.slice(0, 200);

    // 最初のページ分のみ表示
    const startIndex = 0;
    const endIndex = theaterState.itemsPerPage;
    products = theaterState.allProducts.slice(startIndex, endIndex);

    products.forEach((product, index) => {
      const card = this.createTheaterCard(product, index, theaterState);
      if (card) {
        container.appendChild(card);
      }
    });

    // Re-setup button event listeners (cards in theater use the same button structure)
    this.setupCardButtons();

    // Initialize like states for theater cards
    this.initializeLikeStates();

    // Setup video observer
    this.setupTheaterVideoObserver(container, theaterState);

    // Update Load More button and page info
    this.updateTheaterLoadMoreUI(theaterState);
  }

  // Append more items to theater feed (pagination)
  appendTheaterItems(container, theaterState) {
    theaterState.isLoading = true;

    const btn = document.getElementById('v0TheaterLoadMoreBtn');
    if (btn) {
      btn.disabled = true;
      btn.querySelector('span').textContent = '読み込み中...';
    }

    // Small delay for better UX
    setTimeout(() => {
      const startIndex = theaterState.currentPage * theaterState.itemsPerPage;
      const endIndex = startIndex + theaterState.itemsPerPage;
      const products = theaterState.allProducts.slice(startIndex, endIndex);

      products.forEach((product, index) => {
        const globalIndex = startIndex + index;
        const card = this.createTheaterCard(product, globalIndex, theaterState);
        if (card) {
          container.appendChild(card);

          // Observe new video
          const video = card.querySelector('.v0-theater-video');
          if (video && theaterState.videoObserver) {
            theaterState.videoObserver.observe(video);
          }
        }
      });

      // Re-setup button event listeners
      this.setupCardButtons();
      this.initializeLikeStates();

      // Update UI
      theaterState.isLoading = false;
      this.updateTheaterLoadMoreUI(theaterState);

      if (btn) {
        btn.disabled = false;
        btn.querySelector('span').textContent = 'もっと見る';
      }
    }, 300);
  }

  // Create a single theater card
  createTheaterCard(product, index, theaterState) {
    if (!product || !product.preview_url) return null;

    const card = document.createElement('div');
    card.className = 'v0-card v0-theater-item';
    card.dataset.productId = product.id;
    card.dataset.variantId = product.variantId;
    card.dataset.productHandle = product.handle;
    card.dataset.title = product.title;
    card.dataset.preview = product.preview_url;

    const videoSrc = product.preview_url;

    // Check if liked
    const likedProductsV2 = JSON.parse(localStorage.getItem('v0_liked_products_v2') || '[]');
    const isLiked = likedProductsV2.some(p => String(p.id) === String(product.id));
    const likeIconFill = isLiked ? '#ef4444' : 'none';
    const likeIconStroke = isLiked ? '#ef4444' : 'currentColor';
    const likedClass = isLiked ? 'v0-card__btn--liked' : '';

    const safeZoneId = `theater-neon-${index}`;

    let durationDisplay = '0:30';
    if (product.durationDisplay) {
      durationDisplay = product.durationDisplay;
    } else if (product.duration) {
      const duration = parseInt(product.duration);
      const minutes = Math.floor(duration / 60);
      const seconds = duration % 60;
      durationDisplay = minutes > 0
        ? `${minutes}:${seconds.toString().padStart(2, '0')}`
        : `0:${seconds.toString().padStart(2, '0')}`;
    }

    card.innerHTML = `
      <div class="v0-card__media">
        <video class="v0-card__video v0-theater-video" loop playsinline src="${videoSrc}" muted preload="metadata" style="opacity: 1; display: block;" onclick="this.paused ? this.play() : this.pause()" oncontextmenu="return false;"></video>

        <div class="safe-zone-overlay-container">
          <svg class="safe-zone-svg" viewBox="0 0 1080 1920" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <filter id="${safeZoneId}" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="5" result="coloredBlur"/>
                <feMerge>
                  <feMergeNode in="coloredBlur"/>
                  <feMergeNode in="SourceGraphic"/>
                </feMerge>
              </filter>
            </defs>
            <path d="M0,0 H1080 V1920 H0 Z M60,180 H1020 V1400 H900 V1600 H60 Z" fill="rgba(0, 0, 0, 0.6)" fill-rule="evenodd"/>
            <path d="M60,180 H1020 V1400 H900 V1600 H60 Z" fill="none" stroke="#00F0FF" stroke-width="4" filter="url(#${safeZoneId})" opacity="0.9"/>
          </svg>
        </div>

        <div class="v0-card__price-badge">${window.location.pathname.startsWith('/en/') ? '$' + (product.price === 0 ? '0' : (product.price === 200 ? '1.39' : '3.49')) : '¥' + product.price}</div>
        ${product.aiGenerated === 'true' || product.aiGenerated === true ? '<div class="v0-card__ai-badge">AI</div>' : ''}

        <div class="v0-card__actions-top">
          <button class="v0-card__btn ${likedClass}" data-action="like" data-product-id="${product.id}" data-tooltip="いいね" aria-label="いいね">
            <svg width="20" height="20" fill="${likeIconFill}" stroke="${likeIconStroke}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
          </button>
          <button class="v0-card__btn" data-action="share" data-tooltip="シェア" aria-label="シェア">
            <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
            </svg>
          </button>
          <button class="v0-card__btn" data-action="cart" data-variant-id="${product.variantId}" data-product-title="${product.title}" data-tooltip="追加" aria-label="カートに追加">
            <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
          </button>
          <button class="v0-card__btn v0-card__btn--download" data-action="download-with-credit" data-product-id="${product.id}" data-product-title="${product.title}" data-product-price="${product.price}" data-ai-generated="${product.aiGenerated}" data-tooltip="ダウンロード" aria-label="ダウンロード">
            <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
          </button>
        </div>

        <div class="v0-card__meta-capsule">
          <span class="v0-time">${durationDisplay}</span>
          <span class="v0-divider">|</span>
          <span class="v0-resolution">${product.resolution || 'HD'}</span>
        </div>
      </div>
    `;

    return card;
  }

  // Setup Intersection Observer for theater videos
  setupTheaterVideoObserver(container, theaterState) {
    // Disconnect existing observer
    if (theaterState.videoObserver) {
      theaterState.videoObserver.disconnect();
    }

    const observerOptions = {
      root: document.getElementById('v0TheaterModal'),
      rootMargin: '0px',
      threshold: 0.5
    };

    theaterState.videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => { });
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    }, observerOptions);

    const videos = container.querySelectorAll('.v0-theater-video');
    videos.forEach(video => theaterState.videoObserver.observe(video));
  }

  // Update Load More button visibility and page info
  updateTheaterLoadMoreUI(theaterState) {
    const loadMoreContainer = document.getElementById('v0TheaterLoadMore');
    const pageInfo = document.getElementById('v0TheaterPageInfo');

    const totalProducts = theaterState.allProducts.length;
    const displayedCount = Math.min((theaterState.currentPage + 1) * theaterState.itemsPerPage, totalProducts);
    const hasMore = displayedCount < totalProducts;

    if (loadMoreContainer) {
      loadMoreContainer.style.display = hasMore ? 'flex' : 'none';
    }

    if (pageInfo) {
      pageInfo.textContent = `${displayedCount} / ${totalProducts} 件表示`;
    }
  }
}

// グローバルにV0Appクラスを公開（デバッグとテスト用）
window.V0App = V0App;

// 単一インスタンスを保持
let v0AppInstance = null;

// Initialize app when DOM is ready
// Initialize app when DOM is ready or if already loaded
(function () {
  let v0AppInitialized = false;
  const initApp = () => {
    if (v0AppInitialized) return;
    v0AppInitialized = true;
    debugLog('DOMContentLoaded - initializing V0App');

    if (!v0AppInstance) {
      try {
        v0AppInstance = new V0App();
        // インスタンスもグローバルに公開（複数の名前で）
        window.v0AppInstance = v0AppInstance;
      } catch (e) {
        console.error('[V0App] Constructor failed:', e);
        return;
      }

      // Initialize visible products for Theater Mode (Optional now, as renderTheaterFeed has fallback)
      // try {
      //   v0AppInstance.initializeVisibleProducts();
      // } catch (e) {
      //   console.error('[V0App] Failed to initialize visible products:', e);
      // }

      // Setup Theater Mode
      try {
        v0AppInstance.setupTheaterMode();
      } catch (e) {
        console.error('[V0App] Failed to setup Theater Mode:', e);
      }

      // applyFiltersメソッドを直接グローバルに公開
      window.applyFilters = () => v0AppInstance && v0AppInstance.applyFilters();

      // updateVisibleProductsを定義（LOAD MORE後にシアターモードの動画リストを更新）
      window.updateVisibleProducts = () => {
        if (v0AppInstance && typeof v0AppInstance.initializeVisibleProducts === 'function') {
          v0AppInstance.initializeVisibleProducts();
          debugLog('[Theater Mode] visibleProducts updated after LOAD MORE');
        }
      };

      debugLog('V0App initialized successfully');
    } else {
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
  } else {
    initApp();
  }
})();

// 検索ページ: Shopify自動生成の重複ページネーションを非表示
(function hideDuplicateSearchPagination() {
  const paginations = document.querySelectorAll('.pagination-wrapper');

  if (paginations.length > 1) {
    debugLog('[Search Page] Multiple pagination detected, hiding duplicate...');

    paginations.forEach((wrapper, index) => {
      const parent = wrapper.parentElement;
      const grandParent = parent?.parentElement;

      // vf-content > page-width内のページネーション（Shopify自動生成）を非表示
      if (parent?.classList.contains('page-width') && grandParent?.classList.contains('vf-content')) {
        wrapper.style.display = 'none';
        debugLog(`[Search Page] Hidden duplicate pagination(index: ${index + 1})`);
      }
    });
  }
})();

// 重複実行を削除 - コンストラクタで既に実行されているため不要
// setTimeout(() => {
//   if (v0AppInstance) {
//     v0AppInstance.setupVideoHover();
//     v0AppInstance.setupCardButtons();
//     v0AppInstance.setupProductModal();
//   }
// }, 1000);

// Notification and modal styles
const styles = document.createElement('style');
styles.textContent = `
      .v0 - notification {
      position: fixed;
      top: 80px;
      right: 20px;
      background: #10b981;
      color: white;
      padding: 12px 20px;
      border - radius: 8px;
      box - shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateX(400px);
      transition: transform 0.3s ease;
      z - index: 10000;
    }
  
  .v0 - notification--show {
      transform: translateX(0);
    }
  
  .error {
      border - color: #ef4444!important;
    }

  /* カードのサムネイルトランジション */
  .v0 - card__thumbnail,
  .v0 - card__image {
      transition: opacity 0.3s ease;
    }

  /* カードメディアの相対位置 */
  .v0 - card__media {
      position: relative;
      overflow: hidden;
    }

  /* ビデオの初期設定 */
  .v0 - card__video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100 %;
      height: 100 %;
      object - fit: cover;
      opacity: 0;
      z - index: 10;
      transition: opacity 0.3s ease;
    }
    `;
document.head.appendChild(styles);


